// extracted by mini-css-extract-plugin
export default {"templateControls":"templateControls__DF8Cmq","readOnly":"readOnly__at7uiY","templateAlert":"templateAlert__sL0jkq"};